import { Flex, styled, ifProp, selectTheme } from '@creditas-ui/react'
import { InputLabel } from './InputLabel'
import { Input } from './Input'

const InputSearchElement = styled(Flex)`
  height: 64px;
  position: relative;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  padding: ${selectTheme('input.shape.padding')};
  padding-right: 60px;
  border-radius: ${selectTheme('input.shape.borderRadius')};
  background-color: ${ifProp(
    'focused',
    selectTheme('input.shape.focus.backgroundColor'),
    selectTheme('input.shape.backgroundColor'),
  )};
  transition: background-color ${selectTheme('input.shape.transition')};
  z-index: 0;

  &::before {
    content: ' ';
    position: absolute;
    opacity: ${ifProp('focused', 1, 0)};
    border-radius: ${selectTheme('input.shape.borderRadius')};
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    box-shadow: ${selectTheme('input.shape.boxShadow')};
    transition: opacity ${selectTheme('input.shape.transition')};
  }
`

const StyledLabel = styled(InputLabel)`
  position: ${ifProp('active', 'relative', 'absolute')};
  top: ${ifProp('active', '20%', '50%')};
  font-weight: ${selectTheme('fontWeight.sm')};
  transform: ${ifProp('active', 'translateY(-100%)', 'translateY(-50%)')};
  font-size: ${ifProp(
    'active',
    selectTheme('input.placeholder.active.fontSize'),
  )};
  line-height: ${ifProp(
    'active',
    selectTheme('input.placeholder.active.lineHeight'),
  )};
  transition: transform ${selectTheme('input.placeholder.transition')} linear,
    font-size ${selectTheme('input.placeholder.transition')} linear;
`

const StyledInput = styled(Input)`
  font-weight: normal;
  font-size: ${selectTheme('input.shape.fontSize')};
  font-family: ${selectTheme('input.shape.fontFamily')};
  color: ${ifProp(
    'disabled',
    selectTheme('input.shape.disabled.color'),
    selectTheme('input.shape.color'),
  )};
  z-index: 1;
`

export { InputSearchElement, StyledLabel as InputLabel, StyledInput as Input }
